export default "__VITE_ASSET__8d138e78__"